export default __webpack_public_path__ + "static/media/season_2_mapfull.38b98935.png";